import { mixColor, unmixColor } from "alt1";
export class Alt1Color {
    constructor(for_overlay, css_string) {
        this.for_overlay = for_overlay;
        this.css_string = css_string;
    }
    static fromHex(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return new Alt1Color(mixColor(r, g, b), hex);
    }
    static fromNumber(value) {
        const [r, g, b] = unmixColor(value);
        function componentToHex(c) {
            const hex = c.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
        }
        return new Alt1Color(value, "#" + componentToHex(r) + componentToHex(g) + componentToHex(b));
    }
    static fromRGB(r, g, b) {
        return this.fromNumber(mixColor(r, g, b));
    }
}
(function (Alt1Color) {
    Alt1Color.black = Alt1Color.fromHex("#010101"); // #000000 is considered transparent!
    Alt1Color.gray = Alt1Color.fromHex("#808080"); // #000000 is considered transparent!
    Alt1Color.white = Alt1Color.fromHex("#FFFFFF");
    Alt1Color.red = Alt1Color.fromHex("#FF0000");
    Alt1Color.green = Alt1Color.fromHex("#00FF00");
    Alt1Color.blue = Alt1Color.fromHex("#0000FF");
    Alt1Color.yellow = Alt1Color.fromHex("#FFFF00");
    Alt1Color.magenta = Alt1Color.fromHex("#FF00FF");
    Alt1Color.cyan = Alt1Color.fromHex("#00FFFF");
})(Alt1Color || (Alt1Color = {}));
